export interface SidebarRoute {
  path: string
  label: string
  sectionId?: string
}

export interface SidebarRouteConfig {
  sections?: string[]
  routes?: SidebarRoute[]
}

export const sidebarRouteConfig: Record<string, SidebarRouteConfig> = {
  '/about': {
    sections: ['experience', 'countries', 'cities']
  },
  '/photographs': {
    sections: []
  },
  '/explore': {
    routes: [
      { path: '/explore/espresso', label: 'Espresso' },
      { path: '/explore/tattoo', label: 'Tattoo' },
      { path: '/explore/gsl', label: 'GSL' },
      { path: '/explore/4runner', label: '4Runner' }
    ]
  },
  '/explore/espresso': {
    routes: [
      { path: '/explore/espresso', label: 'Espresso' },
      { path: '/explore/tattoo', label: 'Tattoo' },
      { path: '/explore/gsl', label: 'GSL' },
      { path: '/explore/4runner', label: '4Runner' }
    ]
  },
  '/explore/gsl': {
    routes: [
      { path: '/explore/espresso', label: 'Espresso' },
      { path: '/explore/tattoo', label: 'Tattoo' },
      { path: '/explore/gsl', label: 'GSL' },
      { path: '/explore/4runner', label: '4Runner' }
    ]
  },
  '/explore/tattoo': {
    routes: [
      { path: '/explore/espresso', label: 'Espresso' },
      { path: '/explore/tattoo', label: 'Tattoo' },
      { path: '/explore/gsl', label: 'GSL' },
      { path: '/explore/4runner', label: '4Runner' }
    ]
  },
  '/explore/4runner': {
    routes: [
      { path: '/explore/espresso', label: 'Espresso' },
      { path: '/explore/tattoo', label: 'Tattoo' },
      { path: '/explore/gsl', label: 'GSL' },
      { path: '/explore/4runner', label: '4Runner' }
    ]
  },
  '/': {
    sections: ['home', '2020', '2019', '2018', '2015']
  }
}

